import api from '../../../common/api.js'
import {showMessageToast} from '../../Header/Toast/index.js'
import {ensurePO} from '../../../data/pos.js'
import {
  Count,
  plural,
  Plural,
  PluralBlock,
} from '../../../common/components/Plural.js'
import {showConfirmMessageModal} from '../../../common/components/Modal/ConfirmMessageModal.js'

export async function showDeleteGoodsReceiptModal(goodsReceiptIDs) {
  await showConfirmMessageModal({
    title: 'Delete Goods Receipt',
    Message({form}) {
      return (
        <PluralBlock array={form.confirmValue.goodsReceiptIDs}>
          Are you sure you want to delete <Count /> goods{' '}
          <Plural word="receipt" />?
        </PluralBlock>
      )
    },
    confirmValue: {goodsReceiptIDs},
    onResolve: deleteGoodsReceipt,
  })
}

export async function deleteGoodsReceipt({outcome}) {
  if (!outcome) {
    return
  }

  const {goodsReceiptIDs} = outcome

  const responses = await Promise.all(
    goodsReceiptIDs.map((goodsReceiptID) =>
      api.delete(`/goods_receipt/${encodeURIComponent(goodsReceiptID)}/`),
    ),
  )

  const poIDs = Object.keys(
    responses.reduce((prev, {json: {po_id}}) => {
      prev[po_id] = true

      return prev
    }, {}),
  )

  await Promise.all(poIDs.map((poID) => ensurePO(poID, {reload: true})))

  showMessageToast(
    plural(
      goodsReceiptIDs,
    )`${Count} Goods receipt${['s']} ${['were', 'was']} deleted`,
  )
}
